import { z } from "zod";

export const defaultConfig = {
  logo: {
    src: "",
    alt: "",
    url: "",
  },
  menu: [],
  useAccount: false,
  useHelpdesk: false,
};

export const cnbLogoSchema = z.object({
  src: z.string(),
  alt: z.string(),
  url: z.string(),
});

export type cnbLogoType = z.infer<typeof cnbLogoSchema>;

// 기본 메뉴 아이템 스키마
const cnbMenuItemSchema = z.object({
  name: z.string(),
  url: z.string(),
  target: z
    .string()
    .regex(/^_blank|_self+$/)
    .optional(),
  matches: z.array(z.string()).optional(),
  useExactMatch: z.boolean().optional(),
});

export type cnbMenuItemType = z.infer<typeof cnbMenuItemSchema>;

// 재귀적 메뉴 아이템 타입 정의
export type cnbMenuItemWithChildrenType = cnbMenuItemType & {
  children?: cnbMenuItemWithChildrenType[];
};

// 재귀적 메뉴 스키마 정의
const cnbMenuSchema: z.ZodType<cnbMenuItemWithChildrenType[]> = z.array(
  cnbMenuItemSchema.extend({
    children: z.lazy(() => cnbMenuSchema).optional(),
  }),
);

export type cnbMenuType = z.infer<typeof cnbMenuSchema>;

export const cnbConfigSchema = z.object({
  logo: cnbLogoSchema,
  menu: cnbMenuSchema,
  helpdesk: z
    .object({
      isActive: z.boolean(),
      phone: z.string().optional(),
      content: z.string().optional(),
    })
    .optional(),
});

export type cnbConfigType = z.infer<typeof cnbConfigSchema>;
